<div mat-dialog-title class="ds mobile">
  <span id="dialogTitle">{{appStrings.quote_expiredTitle}}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon id="closeButton" class="close-icon">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="content ds" [ngClass]="{'mobile': isMobile}">
  <div class="dialogContent">
    <typography id="dialogText" variant="mat-subtitle-2" weight="bold"> {{appStrings.quote_expiredSubtitle}} </typography>
    <ds-radio-group groupTitle="" groupSubtitle="" orientation="vertical" [values]="radioValues" [control]="expiredQuoteForm.controls.option"></ds-radio-group>
  </div>
</div>
<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button id="cancelBtn" variant="label-only" size="medium" type="secondary" (onClick)="close()" [label]="appStrings.button_cancel">
    </ds-button>
    <ds-button id="confirmBtn" variant="label-only" size="medium" type="primary" (onClick)="confirmSelection()" [label]="appStrings.button_confirm">
    </ds-button>
  </div>
  </div>
